import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components'
import { Navigation24Regular } from '@fluentui/react-icons'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { RestSchemas } from '@/contexts/QueryProvider'
import { AddApplicationForm } from '@/ui/Forms/AddApplicationForm'
import { EditApplicationAttribsForm } from '@/ui/Forms/ApplicationAttribsForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'
import { MaintainAppAdmins } from '../../MaintainAppAdmins'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export function RowActionsMenu({ app }: { app: MessagesApplicationsApplication }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [drawerOpen, setDrawerOpen] = useState<'none' | 'editAdmins' | 'editApp' | 'editAttribs'>('none')

  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<Navigation24Regular />} />
        </MenuTrigger>

        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={() => {
                searchParams.set('tab', 'details')
                searchParams.set('appId', app.applicationId.toString())
                searchParams.set('appName', app.appName)
                setSearchParams(searchParams)
              }}
            >
              View Application
            </MenuItem>
            <MenuItem
              onClick={() => {
                setDrawerOpen('editApp')
              }}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                setDrawerOpen('editAttribs')
              }}
            >
              Edit Attributes
            </MenuItem>
            <MenuItem
              onClick={() => {
                setDrawerOpen('editAdmins')
              }}
            >
              Maintain Administrators
            </MenuItem>
            <MenuItem
              onClick={() => {
                searchParams.set('tab', 'accesses')
                searchParams.set('appId', app.applicationId.toString())
                searchParams.set('appName', app.appName)
                setSearchParams(searchParams)
              }}
            >
              Edit Accesses
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>

      <OverlayDrawerComponent
        key="editform"
        open={drawerOpen === 'editApp'}
        setOpen={(open) => setDrawerOpen(open ? 'editApp' : 'none')}
        title="Edit application"
        content={
          <AddApplicationForm
            edit
            onSubmit={() => {
              setDrawerOpen('none')
            }}
            selectedApp={app}
          />
        }
      />

      <OverlayDrawerComponent
        key="editaadmins"
        size="medium"
        open={drawerOpen === 'editAdmins'}
        setOpen={(open) => setDrawerOpen(open ? 'editAdmins' : 'none')}
        title="Maintain app admins"
        content={<MaintainAppAdmins selectedApp={app} />}
      />

      <OverlayDrawerComponent
        key="editattribsform"
        size="medium"
        open={drawerOpen === 'editAttribs'}
        setOpen={(open) => setDrawerOpen(open ? 'editAttribs' : 'none')}
        title="Edit application attributes"
        content={
          <EditApplicationAttribsForm
            onSubmit={() => {
              setDrawerOpen('none')
            }}
            selectedApp={app}
          />
        }
      />
    </>
  )
}
